import React, {useState} from 'react';
import { Link, NavLink } from 'react-router-dom'
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import './rugby-header.css';


const RugbyHeader = () => {
        // eslint-disable-next-line no-undef
        const [nav, setNav] = useState(false);


    return (
        <header className="header">

            <div className="header-section">
                <Link to='/'><img src='./img/logo.PNG' alt="Logo" className="logo" /></Link>

                <ul className={nav ? ['nav-list', 'nav-list__active'].join(' ') : 'nav-list'}>

                    <li className="nav-list__item" ><NavLink to='/rugby' className='nav-list__item_link'>HOME</NavLink></li>
                    <li className="nav-list__item" ><NavLink to='/rugby-news' className='nav-list__item_link'>NEWS</NavLink></li>
                    <li className="nav-list__item" ><NavLink to='/rugby-team' className='nav-list__item_link'>TEAM</NavLink></li>
                    <li className="nav-list__item" ><NavLink to='/rugby-results' className='nav-list__item_link'>FIXTURES & RESULTS</NavLink></li>
                    <li className="nav-list__item" ><NavLink to='/rugby-coaches' className='nav-list__item_link'>COACHES</NavLink></li>
                    {/* <li className="nav-list__item" ><NavLink to='/rugby-partners' className='nav-list__item_link'>PARTNERS</NavLink></li> */}
                    <li className="nav-list__item" ><NavLink to='/rugby-stats' className='nav-list__item_link'>STATS</NavLink></li>
                </ul>

                <div onClick={() => setNav(!nav)} className='mobile__btn'>
                    {nav ? <AiOutlineClose className='mobile__btn-style'/> : <AiOutlineMenu className='mobile__btn-style' />}
                </div>
            </div>


        </header >
    );
}


export default RugbyHeader